import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import { AnalyticsId, FormOnColor } from "./constants.js";
import { S as Spacer } from "./Spacer.js";
import styles from "./components/Label/styles.module.scss";
import { isComponent } from "./utils/component.js";
import { S as StatusDot } from "./StatusDot.js";
const Sublabel = ({ children, className, id, onColor, sublabelTexts, testId }) => {
  const mapSublabels = (hideFromScreenReader) => {
    return sublabelTexts && sublabelTexts.map((sublabelText, index) => {
      const labelClasses = classNames(styles.label, styles["sublabel"], {
        [styles["sublabel--subdued"]]: sublabelText.type === "subdued",
        [styles["sublabel--on-dark"]]: onColor === FormOnColor.ondark
      });
      return hideFromScreenReader === sublabelText.hideFromScreenReader && /* @__PURE__ */ jsx("span", { className: labelClasses, children: sublabelText.text }, index);
    });
  };
  const subLabels = mapSublabels();
  const ariaHiddenSublabels = mapSublabels(true);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Spacer, { size: "3xs" }),
    (subLabels || children) && /* @__PURE__ */ jsxs("div", { className, id, "data-testid": testId, "data-analyticsid": AnalyticsId.Sublabel, children: [
      subLabels,
      children
    ] }),
    ariaHiddenSublabels && /* @__PURE__ */ jsx("div", { className, "data-testid": testId, children: ariaHiddenSublabels })
  ] });
};
const getLabelText = (label) => {
  var _a;
  let allLabelText = "";
  if (isComponent(label, Label)) {
    (_a = label.props.labelTexts) == null ? void 0 : _a.forEach((labelText) => {
      allLabelText += !labelText.hideFromScreenReader ? labelText.text : "";
    });
  }
  return allLabelText;
};
const renderLabel = (label, inputId, onColor, markup) => {
  return /* @__PURE__ */ jsx(Fragment, { children: label && isComponent(label, Label) ? React__default.cloneElement(label, {
    htmlFor: inputId,
    htmlMarkup: markup || "label",
    onColor
  }) : typeof label === "string" && /* @__PURE__ */ jsx(Label, { labelTexts: [{ text: label, type: "normal" }], htmlFor: inputId, onColor }) });
};
const renderLabelAsParent = (label, children, inputId, onColor, labelClassName, labelTextClassName, sublabelWrapperClassName, large, markup) => {
  return /* @__PURE__ */ jsx(Fragment, { children: label && isComponent(label, Label) ? React__default.cloneElement(label, {
    htmlFor: inputId,
    onColor,
    children,
    labelClassName: classNames(labelClassName, label.props.labelClassName),
    labelTextClassName,
    htmlMarkup: markup || "label",
    sublabelWrapperClassName,
    sublabel: large ? void 0 : label.props.sublabel,
    statusDot: large ? void 0 : label.props.statusDot
  }) : typeof label === "string" && /* @__PURE__ */ jsx(
    Label,
    {
      labelTexts: [{ text: label, type: "subdued" }],
      htmlFor: inputId,
      onColor,
      htmlMarkup: markup || "label",
      labelClassName,
      labelTextClassName,
      sublabelWrapperClassName,
      children
    }
  ) });
};
const Label = ({
  afterLabelChildren,
  children,
  className,
  htmlFor,
  htmlMarkup = "label",
  labelClassName,
  labelTextClassName,
  labelId,
  labelTexts,
  onColor = FormOnColor.onwhite,
  statusDot,
  sublabel,
  sublabelWrapperClassName,
  testId
}) => {
  const hasChildren = children && typeof children !== "undefined";
  const labelWrapperClasses = classNames(
    styles["label-wrapper"],
    { [styles["label-wrapper--no-bottom-margin"]]: hasChildren, [styles["label-wrapper--after-label-children"]]: afterLabelChildren },
    className
  );
  const mapLabels = () => {
    if (typeof labelTexts === "undefined") return null;
    return labelTexts.map((labelText, index) => {
      const labelClasses = classNames(
        styles.label,
        {
          [styles["label--subdued"]]: labelText.type === "subdued",
          [styles["label--on-dark"]]: onColor === FormOnColor.ondark
        },
        labelTextClassName
      );
      return /* @__PURE__ */ jsx("span", { "aria-hidden": labelText.hideFromScreenReader, className: labelClasses, children: labelText.text }, index);
    });
  };
  const CustomTag = htmlMarkup;
  return /* @__PURE__ */ jsxs("div", { className: labelWrapperClasses, children: [
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(CustomTag, { className: labelClassName, id: labelId, htmlFor, "data-testid": testId, "data-analyticsid": AnalyticsId.Label, children: /* @__PURE__ */ jsxs("span", { className: styles["label-content-wrapper"], children: [
        children,
        /* @__PURE__ */ jsx("span", { className: styles.label__texts, children: mapLabels() })
      ] }) }),
      /* @__PURE__ */ jsxs("div", { className: sublabelWrapperClassName, children: [
        sublabel && isComponent(sublabel, Sublabel) && React__default.cloneElement(sublabel, {
          onColor
        }),
        statusDot && isComponent(statusDot, StatusDot) && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Spacer, { size: "3xs" }),
          React__default.cloneElement(statusDot, {
            onColor: onColor === FormOnColor.ondark ? "ondark" : "onwhite"
          })
        ] })
      ] })
    ] }),
    afterLabelChildren && /* @__PURE__ */ jsx("div", { className: styles["after-label-children"], children: afterLabelChildren })
  ] });
};
export {
  Label as L,
  Sublabel as S,
  renderLabel as a,
  getLabelText as g,
  renderLabelAsParent as r
};
//# sourceMappingURL=Label.js.map
